import { Button, Descriptions, Modal } from 'antd';
import styled from 'styled-components';

export const ResponseModal = ({ visible, data, type, onOk }) => {
  return (
    <>
      <StyledValidationModal
        visible={visible}
        style={{ display: 'flex', justifyContent: 'center' }}
        title='Resource Cleanup Summary'
        className='modal-wrap'
        onCancel={onOk}
        footer={
          <>
            <Button type={'primary'} onClick={onOk}>
              Ok
            </Button>
          </>
        }
      >
        {' '}
        {type === 'ProcessCleanupResponse' && data && (
          <Descriptions column={1}>
            <Descriptions.Item label='Total Records Processed'>{data.totalRecordsProcessed}</Descriptions.Item>
            <Descriptions.Item label='Total Service Template Details Records deleted'>
              {data.totalServiceTemplateDetailsDeleted}
            </Descriptions.Item>
            <Descriptions.Item label='Total Provider Blocks Records deleted'>
              {data.totalProviderBlocksDeleted}
            </Descriptions.Item>
            <Descriptions.Item label='Total Service Template Records deleted'>
              {data.totalServiceTemplatesDeleted}
            </Descriptions.Item>
          </Descriptions>
        )}
        {type === 'uploadResponse' && data && (
          <Descriptions column={1}>
            <Descriptions.Item>{data}</Descriptions.Item>
          </Descriptions>
        )}
      </StyledValidationModal>
    </>
  );
};

const StyledValidationModal = styled(Modal)`
  .ant-modal-content {
    width: 250%;
  }
`;

const StyledTitle = styled.div`
  width: 100%;
  text-align: center;
`;
